<template>
  <div class="avr-setting-page">
    <CustomTable
      title="Настройка АВР по конструктивам"
      :rowsData="rowsData"
      :columns="avrSettingColumns"
      :loading="isFetching"
      :show-search="false"
      :custom-body="true"
      :custom-header="true"
      :sticky-header="true"
      :dense="true"
    >
      <template #customHeader="props">
        <q-tr>
          <q-th align="center" class="constructive-header-center">Конструктив</q-th>
          <q-th colspan="2" align="center">
            Параметры создания АВР
          </q-th>
          <q-th align="center" class="actions-header-center">Действия</q-th>
        </q-tr>
        <q-tr>
          <q-th align="left"></q-th>
          <q-th align="center">День месяца</q-th>
          <q-th align="center">Процент</q-th>
          <q-th align="center"></q-th>
        </q-tr>
      </template>
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="left">
            {{ props.row.constructive_name }}
          </custom-table-cell>

          <custom-table-cell align="center">
            {{ props.row.avr_day ?? "" }}
          </custom-table-cell>

          <custom-table-cell align="center">
            {{ props.row.avr_percent != null ? `${props.row.avr_percent}%` : "" }}
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            <CustomIcon @click="() => this.handleUpdateClick(props.row)" icon="edit" />
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomIcon from "@/components/common/CustomIcon";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import { MODAL_NAMES } from "@/constants";
import { useAppStore } from "@/services/store/app";
import {
  getAvrSettings,
  avrSettingColumns,
  updateAvrSetting,
} from "@/views/AvrSetting/services";

export default {
  name: "AvrSetting",
  components: { CustomTable, CustomTableCell, CustomIcon },
  data() {
    return {
      avrSettingColumns,
      rowsData: [],
      isFetching: false,
    };
  },
  methods: {
    async getData() {
      this.isFetching = true;
      const res = await getAvrSettings();
      this.isFetching = false;
      if (res) {
        this.rowsData = res;
      }
    },
    async handleUpdateClick(row) {
      this.showModal(MODAL_NAMES.Edit_Avr_Setting, {
        onSubmit: (body) => this.onUpdateSubmit(row.constructive_guid, body),
        title: "Изменить параметры АВР",
        body: row,
      });
    },
    async onUpdateSubmit(constructive_guid, body) {
      const res = await updateAvrSetting({
        constructive_guid,
        ...body,
      });
      if (!res) return;
      this.rowsData = res;
      this.showSucceedSnackbar();
      this.closeModal();
    },
  },
  mounted() {
    this.getData();
  },
  setup() {
    const { showSucceedSnackbar } = useCustomSnackbar();
    const { showModal, closeModal } = useAppStore();
    return { showSucceedSnackbar, showModal, closeModal };
  },
};
</script>

<style scoped lang="scss">
.avr-setting-page {
  padding: 0;

  // Убираем нижнюю границу и центрируем текст для ячеек заголовка "Конструктив" и "Действия"
  :deep(.constructive-header-center),
  :deep(.actions-header-center) {
    border-bottom: none !important;
    vertical-align: middle !important;
    text-align: center !important;
  }
}
</style>
